import React, { createContext, useState, useEffect, useContext } from "react";
import makeApi, { URLS } from "../Utils/apiURL";
import userDetail from "Stores/userDetail";
import BrandedBootLoader from "Components/common/BrandedBootLoader";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTheme = async () => {
      try {
        const config = {
          // Cache-bust so a normal refresh never serves a stale wl/config from
          // the browser HTTP cache — featuresDisabled must reflect the latest.
          url: `${URLS.whiteLableConfig}?t=${Date.now()}`,
          method: "GET"
        };
        let response = await makeApi(config);
        const themeName = response?.data?.theme || "default";
        // wl/config also carries featuresDisabled. Refresh it on every app load
        // (not just login) so newly-disabled features apply on a plain refresh.
        const featuresDisabled = response?.data?.featuresDisabled || [];
        localStorage.setItem("featuresDisabled", JSON.stringify(featuresDisabled));
        userDetail.setFeaturesDisabled(featuresDisabled);
        setTheme(themeName);
      } catch (err) {
        console.error("Failed to fetch theme config:", err);
        setTheme("default");
      }
    };

    fetchTheme();
  }, []);

  useEffect(() => {
    if (theme) {
      document.body.classList.remove(...document.body.classList);
      document.body.classList.add(`theme-${theme}`);
      setLoading(false);
    }
  }, [theme]);

  if (loading) {
    return <BrandedBootLoader />;
  }

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
